export const API_ENDPOINT = process.env.API_ENDPOINT || 'http://localhost:5001'
export const IMMOBILIENSCOUT_24_PORTAL_URL =
  process.env.IMMOBILIENSCOUT_24_PORTAL_URL || 'http://localhost:5001/scout-portal'
export const VERMIETET_DE_PORTAL_URL =
  process.env.VERMIETET_DE_PORTAL_URL || 'http://localhost:5001/vermietet-de-portal'
export const TRACKING_BUNDLE_URL = process.env.TRACKING_BUNDLE_URL || 'http://localhost:5001'
export const SSO_URL = process.env.SSO_URL || 'http://localhost:3000/login'
export const PUBLIC_URL = process.env.PUBLIC_URL || '/'
export const BUILD_DATE = process.env.BUILD_DATE || '????-??-??'
export const GOOGLE_MAP_API_KEY = process.env.GOOGLE_MAP_API_KEY || ''
export const EXTERNAL_INFO_URLS = {
  HOME_STREET_HOME:
    'https://homestreethome.immobilienscout24.de/vermieten?cmp_id=10-051448&cmp_name=brand_hsh_b2b&cmp_position=ppa_insertion_flow&cmp_creative=infotext',
  PRICE_OVERVIEW_RENT: 'https://www.immobilienscout24.de/anbieten/private-anbieter/lp/preise-vm.html',
  PRICE_OVERVIEW_COMMERCIAL_RENT_AND_SELL:
    'https://www.immobilienscout24.de/anbieten/private-anbieter/lp/preise-fb.html',
  PRICE_OVERVIEW_SELL: 'https://www.immobilienscout24.de/anbieten/private-anbieter/lp/preise-vk.html',
  PRICE_OVERVIEW_T2T: 'https://www.immobilienscout24.de/anbieten/private-anbieter/lp/preise-nm.html',
}
export const SCOUT_MANAGER =
  process.env.SCOUT_MANAGER || 'https://www.sandbox-immobilienscout24.de/scoutmanager/verwaltung/kontaktadressen.html'

export const SCOUT_MANAGER_NEW =
  process.env.SCOUT_MANAGER_NEW ||
  'https://www.sandbox-immobilienscout24.de/scoutmanager/inserieren/app/index.html#/neu/'

export const STATUS_POLL_INTERVAL = Number(process.env.STATUS_POLL_INTERVAL || '1000')

export const BUILD_NUMBER = process.env.BUILD_NUMBER || 'unreleased'

export const ATTACHMENT_NUMBER_LIMIT = 150
export const MULTIMEDIA_MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024

export const HEYIMMO_WIDGET_URL = process.env.HEYIMMO_WIDGET_URL || ''
